import React, { useState, useEffect } from 'react';
import axios from 'axios'; 

function UserList() { // Rename function to reflect content
  const [userData, setData] = useState([]);
  const [limit,setLimit] = useState(5)
  console.log(limit)
  const fetchData = async () => { // Use a descriptive function name
    try {
      // const response = await axios.get('https://jsonplaceholder.typicode.com/posts/1');
      const response = await axios.get(`https://dummyjson.com/users?limit=${limit}`);
      setData(response.data.users);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
 console.log(userData)
  useEffect(() => {
    fetchData();
  }, [limit]); // Empty dependency array ensures data is fetched only once

  return (
    <div style={{margin:'60px',}}>
      <h1 style={{textAlign:'center' , fontSize:'30px'}}>User Data</h1>
      {userData.length > 0 ? ( // Handle empty data gracefully
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {userData.map((data) => (
            <div
              key={data.id} // Use unique identifier (like ID) as key
              style={{
                
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '20px',
                margin: '19px',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                // textAlign: 'center',
                // justifyContent:'center',
                flexDirection:'column',
                width:'320px'
              }}

            >
              
              <p>{data.username}</p>
              <p>{data.birthDate}</p>
              <p>{data.email}</p>
              <p>{data.phone}</p>
              <p>{data.university}</p>
            </div> 
            
        
      ))}
      
      <div className='bttn' style={{marginTop:'160px', marginLeft:'-170px'}}>
        <br/>
        <br/>
      { <button style={{border: '1px solid black' ,
                        borderRadius:'5px',
                        padding:'3px',
                        margin:'20px',
                        marginTop:'10px',
                        position: 'absolute',
                        justifyContent:'center',
                        alignItems:'center',
                        textAlign:'center',
                        
      }} onClick={() => setLimit(limit + 5)} > Click me</button> }
     
      </div>
        
        </div>
      
      ) : (
        <p>Loading user data...</p> // Display loading message
      )}
    </div>
    
  );
}

export default UserList;
